import { render, staticRenderFns } from "./RiskDisclosure.vue?vue&type=template&id=e3f49a7c"
import script from "./RiskDisclosure.vue?vue&type=script&lang=js"
export * from "./RiskDisclosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports